import { GetContextMenuItemsParams, MenuItemDef } from 'ag-grid-community'
import { intl } from '../../../../i18n'
import {
  ContextMenuItemId,
  getMenuIconHtml,
} from '../../../containers/commons/AgGrid/lib/contextMenu'
import {
  focusRow,
  getSelectedNode,
} from '../../../containers/BulkSheetView/lib/gridApi'
import {
  SubStatusRow,
  createNewSubStatusRow,
  isDeletableSubStatusRow,
} from '../SubStatusRow'

// 検証エラー(必須未入力・重複名)のセル背景も TicketTypes 画面の名称エラーに揃える。
export const ERROR_CELL_BACKGROUND = '#FADBD8'

/**
 * サブステータス用のコンテキストメニュー(行追加・削除のみ)
 */
export const createContextMenuItems = (
  params: GetContextMenuItemsParams,
  rowData: SubStatusRow[],
  handleDataChange: (newData: SubStatusRow[]) => void,
  handleDeleteRows: () => void,
  handleOpenAddMultipleRows: () => void
): MenuItemDef[] => {
  const selectedNodes = getSelectedNode(params.api)
  // 使用中の行が1つでも含まれていたら削除させない(TicketTypes 画面と同じ挙動)。
  const hasUsedRow = selectedNodes.some(
    node => !isDeletableSubStatusRow(node.data)
  )

  return [
    {
      name: intl.formatMessage({ id: 'bulksheet.contextMenu.insert.row' }),
      icon: getMenuIconHtml(ContextMenuItemId.ADD_ROW),
      action: () => {
        const newRow = createNewSubStatusRow()
        handleDataChange([...rowData, newRow])
        focusRow(params.api, newRow.uuid)
      },
    },
    {
      name: intl.formatMessage({
        id: 'bulksheet.contextMenu.insert.multipleRow',
      }),
      icon: getMenuIconHtml(ContextMenuItemId.ADD_MULTIPLE_ROW),
      action: handleOpenAddMultipleRows,
    },
    {
      name: intl.formatMessage(
        { id: 'bulksheet.contextMenu.delete' },
        { count: selectedNodes.length }
      ),
      icon: getMenuIconHtml(ContextMenuItemId.REMOVE_ROW),
      action: handleDeleteRows,
      shortcut: intl.formatMessage({
        id: 'bulksheet.contextMenu.shortcut.row.delete',
      }),
      disabled: selectedNodes.length === 0 || hasUsedRow,
    },
  ]
}
